import type { IconProps } from '../types';

export const defaultIconProps: IconProps = {
  width: 20,
  height: 20,
  fill: 'currentColor',
  variant: 'filled',
};
